import { ACCOUNT_TYPE, selectUserData, updateValue } from '../accountSlice'
import ContactChangeBlocked from 'components/ContactChangeBlocked'
import { parseApiErrors, pickFieldError } from 'rest/apiErrors'
import useContactChangeLock from 'hooks/useContactChangeLock'
import { finalExp, initialExp } from 'utils/validation'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Submit from 'components/inputs/Submit'
import Input from 'components/inputs/Input'
import Popup from 'components/popups/Popup'
import { STATUS } from 'utils/constants'
import { POST } from 'rest/request'
import { user } from 'rest/urls'
import { useState } from 'react'

const type = ACCOUNT_TYPE.basic

const EditMailPopup = ({ isAdditionalMail = false }) => {

  const { data = {} } = useSelector(state => selectUserData(state, type))
  const [status, setStatus] = useState(STATUS.idle)
  const [warning, setWarning] = useState('')
  const [mail, setMail] = useState('')
  const [password, setPassword] = useState('')
  const [passwordWarning, setPasswordWarning] = useState('')

  const { hasRentals } = useContactChangeLock()
  const isLocked = hasRentals && (!isAdditionalMail || !!data?.additional_email)

  const dispatch = useDispatch()
  const { goBack } = useHistory()
  const { t } = useTranslation('form')
  const updateVal = (name, value) => dispatch(updateValue({ type, name, value }))

  const submit = async () => {
    const body = isAdditionalMail ? { additional_email: mail } : { email: mail }
    setStatus(STATUS.pending)

    try {
      const response = await POST(`${user}/email`, { body: { ...body, password } }, false)
      if (response) {
        updateVal('data', { ...data, ...body })
        goBack()
      } else {
        throw new Error('Wrong response')
      }

    } catch (error) {
      setStatus(STATUS.failed)
      const { fields } = parseApiErrors(error)
      const contactError = pickFieldError(fields, ['email', 'additional_email'])
      const passwordError = pickFieldError(fields, ['password', 'current_password'])
      if (contactError) setWarning(contactError)
      if (passwordError) setPasswordWarning(passwordError)
    }
  }

  const validateMail = () => {
    const isMailValid = !!mail.match(finalExp.mail)
    if (!isMailValid) setWarning(t(mail ? 'wrongEmail' : 'enterEmail'))
    if (!password) setPasswordWarning(t('enterPassword'))
    if (isMailValid && password) submit()
  }

  return (
    <Popup>
      <div className='popup__verification'>
        <div className='popup__title'>
          <div>{t(isAdditionalMail ? 'changeAdditionalEmailAddress' : 'changeEmailAddress')}</div>
        </div>

        {isLocked
          ? <ContactChangeBlocked />
          : <div className='popup__form'>
            <Input
              required
              value={mail}
              name='mail'
              label={t('email')}
              minLength='4'
              maxLength='100'
              warning={warning}
              placeholder={t('enterEmail')}
              disabled={status === STATUS.pending}
              blurHandler={() => {
                setWarning(mail.match(finalExp.mail) ? '' : t('wrongEmail'))
              }}
              changeHandler={e => {
                const { value } = e.target
                if (!value || value.match(initialExp.mail)) setMail(value)
              }} />

            <Input
              required
              name='password'
              type='password'
              autoComplete='current-password'
              value={password}
              label={t('currentPassword')}
              minLength='6'
              maxLength='90'
              warning={passwordWarning}
              placeholder={t('enterPassword')}
              disabled={status === STATUS.pending}
              changeHandler={e => {
                setPassword(e.target.value)
                if (passwordWarning && e.target.value) setPasswordWarning('')
              }} />

            <Submit
              text={t((isAdditionalMail ? data?.additional_email : data?.email) ? 'change' : 'add')}
              block={status === STATUS.pending}
              isLoading={status === STATUS.pending}
              action={validateMail} />
          </div>}
      </div>
    </Popup>
  )
}

export default EditMailPopup